interface LabelProps {
	cx?: number;
	cy?: number;
	midAngle?: number;
	innerRadius?: number;
	outerRadius?: number;
	name?: string;
	percentage?: number;
	payload?: any;
	[key: string]: any;
}

const RADIAN = Math.PI / 180;

export const calculateLabelPosition = (
	cx: number,
	cy: number,
	midAngle: number,
	innerRadius: number,
	outerRadius: number
) => {
	const radius = innerRadius + (outerRadius - innerRadius) * 0.6;
	const x = cx + radius * Math.cos(-midAngle * RADIAN);
	const y = cy + radius * Math.sin(-midAngle * RADIAN);
	return { x, y };
};

export const renderPieLabel = (props: LabelProps, centered = false) => {
	const { cx = 0, cy = 0, midAngle = 0, innerRadius = 0, outerRadius = 0, payload } = props;
	const name = props.name || payload?.name || '';
	const percentage = props.percentage || payload?.percentage || 0;

	const { x, y } = centered
		? { x: cx, y: cy }
		: calculateLabelPosition(cx, cy, midAngle, innerRadius, outerRadius);

	return (
		<text
			x={x}
			y={y}
			fill="white"
			textAnchor="middle"
			dominantBaseline="central"
			className="pie-label"
		>
			<tspan x={x} dy="-0.5rem" className="pie-label-name">
				{name}
			</tspan>
			<tspan x={x} dy="1.2rem" className="pie-label-percentage">
				{percentage}%
			</tspan>
		</text>
	);
};
